document.addEventListener('DOMContentLoaded', (e) => {
  ['de-DE', 'en'].forEach((lang) => {
    const vooLink = document.querySelector(`.footer-bar__list [data-voo-lang="${lang}"]`);
    const vooLinkHeader = document.querySelector(`.dropdown-localization .country-selector__list [data-voo-lang="${lang}"]`);
    const alternateLink = document.querySelector(`link[rel="alternate"][hreflang="${lang}"]`);

    if (alternateLink instanceof HTMLLinkElement) {
      if (vooLinkHeader instanceof HTMLAnchorElement) vooLinkHeader.href = alternateLink.href;
      if (vooLink instanceof HTMLAnchorElement) vooLink.href = alternateLink.href;
    }
  });
});
